<template>
  <div class="components_warp" style="position: relative">
    <img class="close" src="../../../../assets/login/close.png" @click="$router.go(-1)" v-cloak >
    <div class="top-container" style="width:100%;">
         <h2>
               运动点操作演示
              </h2>

          <div class="modal-body">
              <div id="video">
                <video-player class="vjs-custom-skin"
                              ref="videoPlayer"
                              :options="playerOptions"
                              :playsinline="true"
                              @ended="onPlayerEnded($event)">
                </video-player>
              </div>
            </div>
        </div>
  </div>
</template>

<script>
require('video.js/dist/video-js.css');
  require('vue-video-player/src/custom-theme.css')
export default {
    data(){
         return{
         playerOptions: {
          muted: true,
          language: 'zh-CN',
          sources: [{
            type: "video/mp4",
            src: "/ceping/video1.mp4"
          }],
//          poster: "/static/images/author.jpg",
        },
     }
    }
}
</script>

<style scoped>
h2{
  font-size: 20px;
  font-weight: 600;
  position: relative;
  top:-20px;
}
.components_warp{
      display: flex;
    justify-content: center;
    align-items: center;
  height: 100%;
}
.close{
  position: absolute;
  z-index: 9999;
  right: 0;
  top:0;
  cursor: pointer;
}
</style>